<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('message.help.header') }}</v-toolbar-title>
    </v-toolbar>

    <v-expansion-panels :accordion="true">
      <v-expansion-panel>
        <v-expansion-panel-header>{{
          $t('message.help.audioVideoHelp.title')
        }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <ul>
            <li>{{ $t('message.help.audioVideoHelp.step1') }}</li>
            <li>
              {{ $t('message.help.audioVideoHelp.step2') }}
              <v-img src="../assets/help/help_permissions.jpg"></v-img>
            </li>
            <li>
              {{ $t('message.help.audioVideoHelp.step3') }}
              <v-img src="../assets/help/permissions_site.jpg"></v-img>
            </li>
            <li>
              {{ $t('message.help.audioVideoHelp.step4') }}
              <v-img src="../assets/help/change_permission.jpg"></v-img>
            </li>
            <li>
              {{ $t('message.help.audioVideoHelp.step4') }}
            </li>
          </ul>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>{{
          $t('message.help.browserCompatibility.title')
        }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <ul>
            <li>
              Android
              <ul>
                <li>Chrome</li>
                <li>Firefox</li>
                <li>Opera</li>
              </ul>
            </li>
            <li>
              iOS 11+
              <ul>
                <li>Safari</li>
              </ul>
            </li>
            <li>
              MacOs
              <ul>
                <li>Chrome</li>
                <li>Firefox</li>
                <li>Safari</li>
                <li>Opera</li>
              </ul>
            </li>
            <li>
              Windows
              <ul>
                <li>Chrome</li>
                <li>Firefox</li>
                <li>Edge (Chromium version)</li>
                <li>Opera</li>
              </ul>
            </li>
          </ul>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
export default {
  props: {
    closeDialog: { type: Function }
  }
};
</script>

<style></style>
